import { useEffect } from "react";
import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import { RouterProvider } from "react-router-dom";
import "@styles/App.css";
import { reactPlugin } from "./Components/ErrorHandling/appInsights";
import { Notification } from "@components/Notification/Notification";
import { GlobalError } from "./Components/ErrorHandling/globalError";
import { router } from "@routing/mainRouting";
import { useShippingApi } from "@/hooks/apiHooks/useShippingApi";
import { useEndSessionOnSignOut } from "@/hooks/useEndSessionOnSignOut";

function App() {
    const { getPolicy } = useShippingApi();
    useEndSessionOnSignOut();

    // Hydrate the shipping policy once at app init. The endpoint is anonymous,
    // so this runs regardless of auth state. On failure the atom keeps its Q11
    // default fallback; useApi surfaces the error toast.
    useEffect(() => {
        getPolicy().catch(() => {
            /* atom retains its default; notification layer surfaces errors */
        });
    }, [getPolicy]);

    return (
        <AppInsightsErrorBoundary
            onError={() => <GlobalError />}
            appInsights={reactPlugin}
        >
            <div data-theme="light">
                <Notification />
                <RouterProvider router={router} />
            </div>
        </AppInsightsErrorBoundary>
    );
}

export default App;
